import React, { useState, useEffect } from "react";
import { Loader, Pagination } from "semantic-ui-react";
import { map, size } from "lodash";
import { useTranslation } from "react-i18next";
import { supportAPI } from "../../../api";
import { SupportItems } from "../SupportItems";
import "./SupportList.scss";

const supportController = new supportAPI();

export function SupportList(props) {
  const { reload, onReload, accessToken, user } = props;
  const { t } = useTranslation("support");
  const [tickets, setTickets] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    (async () => {
      try {
        const response = await supportController.getTicketsByUser(
          accessToken,
          user.user._id,
          { page, limit: 5 }, // parámetros
        );
        // Suponiendo que el backend usa mongoose-paginate
        // y te devuelve en result.tickets => { docs, totalDocs, page, limit, totalPages, etc. }
        setTickets(response.tickets.docs);
        setPagination({
          total: response.tickets.totalDocs,
          page: response.tickets.page,
          limit: response.tickets.limit,
          pages: response.tickets.totalPages,
        });
        console.log("tickets", response.tickets);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [page, reload, accessToken, user]);

  const changePage = (e, data) => {
    setPage(data.activePage);
  };

  if (!tickets) return <Loader active inline="centered" />;
  if (size(tickets) === 0) return <h2>{t("list.noTickets")}</h2>;

  return (
    <div className="list-ticket">
      {map(tickets, (ticket) => (
        <SupportItems
          key={ticket._id}
          ticket={ticket}
          onReload={onReload}
          user={user}
          accessToken={accessToken}
        />
      ))}

      {pagination && (
        <div className="list-ticket__pagination">
          <Pagination
            defaultActivePage={pagination.page}
            totalPages={pagination.pages}
            ellipsisItem={null}
            firstItem={null}
            lastItem={null}
            onPageChange={changePage}
          />
        </div>
      )}
    </div>
  );
}
